import { useState } from "react"

export function RespuestaTerminosCondi({i,title,contenido}){

  const [active, setActive] = useState(false)
  
  const handleClick = () => {
    setActive(!active)
  }
    return(
        <details className="masDetalle" onClick={handleClick}>
                <summary>
                  <p><span>{i}.</span> {title} </p>
                </summary>
                <div className="justificarText">
                  {contenido.map((item, index) => (
                    <p key={index}>{item}</p>
                  ))}
                </div>
              </details>

    )
}